import { CLEAR_BUTTON_ERRORS } from 'root/src/client/logic/form/actionIds'
import dissocPath from 'ramda/src/dissocPath'

export default {
	[CLEAR_BUTTON_ERRORS]: (state, { moduleKey }) => dissocPath(['form', moduleKey, 'buttonErrors'], state),
}
